// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"eb056d69","297":"1a824873","420":"e3848c5a","461":"049a5c63","709":"0c3095c4"}[chunkId] + ".chunk.js";
};